
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F2994A","d":"M67.68 10H12.32A4.316 4.316 0 008 14.335V51.36a4.316 4.316 0 004.32 4.334h55.36c2.412 0 4.32-1.95 4.32-4.334V14.335C72.034 11.95 70.091 10 67.68 10z"}}),_c('path',{attrs:{"fill":"#FFCEA0","d":"M57.673 61.98H22.289c-2.195 0-3.995 1.807-3.995 4.01 0 2.204 1.8 4.01 3.995 4.01h35.384c2.195 0 3.995-1.806 3.995-4.01a3.994 3.994 0 00-3.995-4.01z"}}),_c('path',{attrs:{"fill":"#DE8E44","d":"M36.03 55.707v6.286h7.955v-6.286H36.03z"}}),_c('path',{attrs:{"fill":"#C57328","d":"M51.5 35.667c-6.552 0-11.927 4.831-12.457 10.98-.047.55.405.999.957.999h23c.552 0 1.004-.45.957-1-.53-6.148-5.905-10.98-12.457-10.98z"}}),_c('circle',{attrs:{"cx":"51.5","cy":"26.292","r":"7.292","fill":"#C57328"}}),_c('path',{attrs:{"fill":"#C57328","fill-rule":"evenodd","d":"M16 26.907c0-1.515 1.716-2.43 3.014-1.584l5.941 3.876.001-.013 5.734 3.726a1.865 1.865 0 010 3.153l-11.677 7.602C17.73 44.499 16 43.598 16 42.083V26.907z","clip-rule":"evenodd"}})])
          )
        }
      }
    